import { render, staticRenderFns } from "./BlockedContentWarning.vue?vue&type=template&id=4ecebc82&scoped=true"
import script from "./BlockedContentWarning.vue?vue&type=script&lang=js"
export * from "./BlockedContentWarning.vue?vue&type=script&lang=js"
import style0 from "./BlockedContentWarning.vue?vue&type=style&index=0&id=4ecebc82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecebc82",
  null
  
)

export default component.exports